<template>
  <el-container>
    <el-main class="el-mainContent">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="obpm-header-nav">
        <el-breadcrumb-item :to="{ path: '/home' }">{{$t('location')}}</el-breadcrumb-item>
        <el-breadcrumb-item>
          <template>
            <i @click="$emit('exit')" style="font-style:normal;" class="pointer">{{$t('super_user_list')}}</i>
          </template>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <template>
            <i style="font-style:normal;">{{$t('superuser_detail')}}</i>
          </template>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight">
        <el-col :span="16" class="normalLineH">{{$t('add_field')}}</el-col>
        <el-col :span="8" style="text-align:right" class="normalLineH">
          <el-button type="primary" @click="onSaveBtnClick('form')" size="small">{{$t('save')}}</el-button>
          <el-button type="primary" plain @click="$emit('exit')" size="small">{{$t('back')}}</el-button>
        </el-col>
      </el-row>
      <el-form ref="form" :model="content" label-position="top" size="mini" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('username')" prop="name" class="padding0Label">
              <el-input type="text" v-model="content.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="6">
            <el-form-item :label="$t('loginno')" prop="loginno" class="padding0Label">
              <el-input type="text" v-model="content.loginno"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('password')" prop="loginpwd" class="padding0Label">
              <el-input type="password" v-model="content.loginpwd" @change="changePwd"></el-input>
              <!-- v-model="content.loginpwd" -->
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="6">
            <el-form-item :label="$t('email')" prop="email" class="padding0Label">
              <el-input type="text" v-model="content.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('fettle')" class="padding0Label">
              <el-switch v-model="content.status" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="accessToken" class="padding0Label">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                :placeholder="$t('placeholder_enter_content')"
                v-model="accessToken"
              ></el-input>
              <el-button size="mini" style="margin-top:5px" @click="onGenAccessTokenBtnClick">{{$t('generate')}}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="6" class="specialPadding0">
            <el-form-item :label="$t('user_type')" prop="type" v-if="!isOpen">
              <el-checkbox v-model="content.superAdmin">{{$t('superAdmin')}}</el-checkbox>
              <el-checkbox v-model="content.developer">{{$t('develop')}}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('management_scope')" v-if="isOpen">
              <el-form-item :label="$t('belong_domains')" class="padding0Label" prop="domains">
                <el-select v-model="content.domains" :disabled="domainDisable" filterable  :placeholder="$t('placeholder_select')" @change="changeSelectDoamin">
                  <!-- multiple -->
                  <el-option
                    v-for="item in domains.datas"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form-item>
            <el-form-item :label="$t('belong_dept')"  v-if="isOpen" class="padding0Label super_select_width" prop="departments">
              <el-select v-model="content.departments" filterable multiple :placeholder="$t('placeholder_select')" no-match-text="无匹配部门">
                <el-option
                  v-for="item in depts.datas"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('key')" class="padding0Label">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                :placeholder="$t('placeholder_enter_content')"
                v-model="content.secret"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  props: ["detail"],
  created() {
    if(this.$store.state.currentUser.isOpenSecurity){
      this.isOpen=true;
    }
    this.content = JSON.parse(JSON.stringify(this.detail));
    this.pwdPre = this.content.loginpwd;
    this.getDomain();
    this.level=this.$store.state.currentUser.level;
    if(!this.content.id){
      //新建用户
      if(this.$store.state.currentUser.domains.length>0 && this.isOpen){
        //现在登陆的是域级用户，所以新建的时候所属于只读，所属部门必填
        this.content.domains=this.$store.state.currentUser.domains[0].id;
        this.getDept();
        this.domainDisable=true;
        this.deptMust=true;
      }

    }else{
      if(this.content.domains && this.isOpen){
        this.getDept();
      }
    }


  },
  data() {
    var emailCheck = (rule, value, callback) => {
      let re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      } else if (!re.test(value)) {
        return callback(new Error("请输入正确的邮箱"));
      } else {
        return callback();
      }
    };
    var pwdCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (value.toString().length < 6 || value.toString().length > 160) {
        callback(new Error("密码长度为6 - 16个字符"));
      } else {
        callback();
      }
    };
    var deptCheck = (rule, value, callback) => {
      if (!value && this.deptMust) {
        callback(new Error("所属部门必填"));
      }  else {
        callback();
      }
    }
    return {
      content: {},
      rules: {
        name: [
          { required: true, message: "请输入用户名称", trigger: "blur" },
          { min: 1, max: 15, message: "长度在 1 到 5 个字符", trigger: "blur" }
        ],
        loginno: [
          { required: true, message: "请输入用户名称", trigger: "blur" },
          { min: 1, max: 15, message: "长度在 1 到 5 个字符", trigger: "blur" }
        ],
        loginpwd: [
          { required: true, trigger: "blur" },
          { validator: pwdCheck, trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: emailCheck, message: "邮箱格式不正确", trigger: "blur" }
        ],
        domains: [
          { required: true, message: "所属域必填", trigger: "blur" },
        ],
        dept: [
          { validator: deptCheck, message: "所属部门必填", trigger: "change" }
        ],
      },
      first: true,
      password: "666666qqqq",
      pwdPre: "",
      checked: false,
      accessToken: "",
      searchdata:{
        currpage: 1,
        pagelines: 1000000,
        data:{
          name:"",
          username:''
        }
      },
      domains:[],
      depts:[],
      isOpen:false,//是否开启安全开关
      level:null,//记录当前登陆用户的级别
      domainDisable:false,//当前是新建用户且是域级用户登陆
      deptMust:false,//域级用户登录，新建用户所属部门必填
    };
  },

  methods: {
    changeSelectDoamin(){
      this.getDept();
    },
    getDept(){
      let params= {
        domainid: this.content.domains,
        superiorid: "",
        currpage: 1,
        pagelines: 10000000,
        orderby: "",
        data:{
          name: "",
        }
      };
      this.$api.getSubDepartments(params, {
        onSucess: resp => {
          this.depts = resp.data.data;
        }
      });
    },
    getDomain(){
      this.$api.getDomains(this.searchdata, {
        onSucess: response => {
          this.domains = response.data.data;
        }
      });
    },
    changePwd(val) {
      if (val !== this.pwdPre) {
        this.password = "";
      } else {
        this.password = "666666qqqq";
      }
    },
    processPassword(pw) {
      let Base64 = require("js-base64").Base64;
      var str = Base64.encode(pw);
      if (str.length > 2) {
        var lp = str.substr(0, 2);
        var rp = str.substr(2, str.length);
        pw = rp + lp;
      }
      return pw;
    },
    onBackList() {},
    onGenAccessTokenBtnClick() {
      this.$api.genAccessToken(this.content.id, {
        onSucess: resp => {
          if (resp.status == 200 && resp.data && resp.data.errcode == 0) {
            this.accessToken = resp.data.data.accessToken;
          }
          else {
              this.accessToken = "ERROR";
          }
        }
      });
    },
    onSaveBtnClick(formName) {
      this.$refs[formName].validate((valid, errmsg) => {
        if (valid) {
          if (this.password != "666666qqqq" && this.content.loginpwd) {
            this.content.loginpwd = this.processPassword(this.content.loginpwd);
          } else if (
            this.password != "666666qqqq" &&
            this.content.loginpwd == ""
          ) {
            this.$message({
              showClose: true,
              message: "用户密码为必填项",
              type: "error"
            });
            return false;
          } else {
            this.content.loginpwd = "666666qqqq";
          }
        
          let content = {
            name: this.content.name,
            loginno: this.content.loginno,
            password: this.content.loginpwd,
            email: this.content.email,
            status: this.content.status,
            "issuperadmin": this.content.superAdmin,
            "isdeveloper": this.content.developer,
            "domains": [this.content.domains],
            "departments": this.content.departments,
            "type":this.content.type
          };
          if (this.content.id) {
            //更新

            this.$api.saveSuperUser(
              {
                id: this.content.id,
                data: content
              },
              {
                onSucess: resp => {
                  if (resp.data.errcode == 0) {
                    this.$message({
                      showClose: true,
                      message: this.$t('msg_save_success'),
                      type: "success"
                    });
                    this.password = "666666qqqq";
                    this.$emit("exit");
                  } else {
                    this.$message({
                      showClose: true,
                      message: resp.data.errmsg,
                      type: "error"
                    });
                  }
                },
                onError: resp => {
                  this.$message({
                    showClose: true,
                    message: resp.data.errmsg,
                    type: "false"
                  });
                }
              }
            );
          } else {
            //新建

            this.$api.createSuperUser(
              {
                data: content
              },
              {
                onSucess: resp => {
                  if (resp.data.errcode == 0) {
                    this.$message({
                      showClose: true,
                      message: this.$t('msg_save_success'),
                      type: "success"
                    });
                    this.password = "666666qqqq";
                    this.$emit("exit");
                  } else {
                    this.$message({
                      showClose: true,
                      message: resp.data.errmsg,
                      type: "error"
                    });
                  }
                },
                onError: resp => {
                  this.$message({
                    showClose: true,
                    message: resp.data.errmsg,
                    type: "error"
                  });
                }
              }
            );
          }
        } else {
          let m = "";
          for (let i in errmsg) {
            errmsg[i].forEach(elm => {
              m += elm.message;
            });
          }
          this.$message({
            showClose: true,
            message: m,
            type: "error"
          });
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>